// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__UdJAY","footer":"ModalError_footer__3w5wl"};